import BaseModule from '../../../javascripts/helpers/baseModule';

export default class Tombstones extends BaseModule {
  constructor(element) {
    super(element, 'tombstones', [{ selector: 'button', id: 'buttons' }]);
  }

  // triggered once in BaseModule
  init() {
    if (this.elements.buttons && this.elements.buttons.asList) {
      this.elements.buttons.asList.forEach((button, buttonIndex) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          const ref = button.dataset.modalId;
          const modal = document.getElementById(ref);
          const modalEvent = new CustomEvent('openModal');
          modal.dispatchEvent(modalEvent);
        });
      });
    }
  }
}
